module.exports = __webpack_public_path__ + "pnskfsquadron/img/fb-ja.jpg?dd73364b";